// ✅ US Market Support - Thin Wrapper (DRY principle)
import SupportPage from '../../sub/support';
import SEOHead from '../../../components/SEOHead';

export default function USSupport() {
  return (
    <>
      <SEOHead
        title='Support | Customer Support | LBVisible'
        description='Get help with your website, SEO, or digital marketing services.'
        keywords='customer support USA, web development support'
        canonicalUrl='/us/sub/support'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/support' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/support' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/pagalba' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/support' },
        ]}
      />

      <SupportPage />
    </>
  );
}
